/** Convex document ids in this deployment are 32-char lowercase alphanumeric. */
const CONVEX_DOCUMENT_ID = /^[a-z0-9]{32}$/i

/**
 * Recover a job id from a public role URL param.
 *
 * Some share targets concatenate the share title onto the URL, producing
 * `/jobs/<id> Project Associate at Unwind`. Convex then rejects the whole
 * string as an invalid id and the role page crashes.
 */
export function parseJobRouteId(raw: string): string | null {
  const token = raw.trim().split(/[\s/?#]+/)[0] ?? ""
  return CONVEX_DOCUMENT_ID.test(token) ? token : null
}
